import {
	DEFAULT_MAP_BY_NETWORK,
	DEFAULT_QUERY_STATUS,
	DEFAULT_SWAP_SLIPPAGE,
	ZERO_CM_FEES,
} from 'state/constants'

import { SnxPerpsV2State } from './types'

export const SMART_MARGIN_INITIAL_STATE: SnxPerpsV2State = {
	markets: {
		11155420: [],
		10: [],
	},
	dailyMarketVolumes: {},
	fundingRates: [],
	queryStatuses: {
		markets: DEFAULT_QUERY_STATUS,
		snxV2BalanceInfo: DEFAULT_QUERY_STATUS,
		dailyVolumes: DEFAULT_QUERY_STATUS,
		positions: DEFAULT_QUERY_STATUS,
		positionHistory: DEFAULT_QUERY_STATUS,
		openOrders: DEFAULT_QUERY_STATUS,
		tradePreview: DEFAULT_QUERY_STATUS,
		account: DEFAULT_QUERY_STATUS,
		trades: DEFAULT_QUERY_STATUS,
		marginTransfers: DEFAULT_QUERY_STATUS,
		historicalFundingRates: DEFAULT_QUERY_STATUS,
		futuresFees: DEFAULT_QUERY_STATUS,
		futuresFeesForAccount: DEFAULT_QUERY_STATUS,
		swapDepositBalanceQuote: DEFAULT_QUERY_STATUS,
		swapDepositQuote: DEFAULT_QUERY_STATUS,
		subAccountsForSnxV2Account: DEFAULT_QUERY_STATUS,
		delegatesForSnxV2Account: DEFAULT_QUERY_STATUS,
		orderHistory: DEFAULT_QUERY_STATUS,
		selectedTraderPositionHistory: DEFAULT_QUERY_STATUS,
		globalTradesHistory: DEFAULT_QUERY_STATUS,
	},
	accounts: DEFAULT_MAP_BY_NETWORK,
	orderFeeCap: '0',
	fees: ZERO_CM_FEES,
	previews: {
		trade: null,
		close: null,
		edit: null,
	},
	globalTradeHistory: {},
	previewDebounceCount: 0,
	cancellingOrder: undefined,
	historicalFundingRates: {},
	totalFuturesFeesPaid: '0',
	futuresFeesForAccount: '0',
	swapDepositSlippage: DEFAULT_SWAP_SLIPPAGE,
	swapDepositCustomSlippage: '',
	leaderboard: {
		selectedTraderV2PositionHistory: DEFAULT_MAP_BY_NETWORK,
	},
}
